import i18next from "i18next";
import { lazy } from "react";
import en from "./i18n/en";
import bg from "./i18n/bg";
import { CleaningSessionProvider } from "./context/CleaningSessionContext";

i18next.addResourceBundle("en", "cleanPage", en);
i18next.addResourceBundle("bg", "cleanPage", bg);

const Clean = lazy(() => import("./Clean"));

/**
 * The Clean page config.
 */
const CleanConfig = {
  settings: {
    layout: {},
  },
  auth: ["Godfather", "Admin", "Cleaner", "Main Cleaner", "Reception"],
  routes: [
    {
      path: "clean",
      element: (
        <CleaningSessionProvider>
          <Clean />
        </CleaningSessionProvider>
      ),
    },
  ],
};

export default CleanConfig;
